import { connect } from 'react-redux'
import StoreBoardCard from '../components/StoreBoardCard'
import * as api from '../../../actions/api'
import * as actions from '../../../actions'

const mapStateToProps = (state, ownProps) => {
  const { records, editingBoardId, ready } = state.storeBoardCard
  return ({
    records,
    editingBoardId,
    ready,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    init: () => {
      dispatch(api.board.select())
    },
    unmount: () => {
      dispatch(actions.storeBoardCard.unmount())
    },
    recordMenuProps: {
      handleEdit: (id, boardContext) => () => {
        dispatch(actions.storeBoardCard.recordMenu.edit(id, boardContext))
      },
      handleDelete: (id, isEditing) => () => {
        if (isEditing) {
          dispatch(actions.webBoard.refresh(false))
        }
        dispatch(api.board.delete(id))
      },
    }
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StoreBoardCard)



// WEBPACK FOOTER //
// ./src/Pages/WebBoard/containers/StoreBoardCard.js